import { gql } from 'graphql-request';

export const createManualShipmentGql = gql`
  mutation createShipment($input: CreateShipmentInput!) {
    createShipment(input: $input) {
      shipmentId
      referenceId
      status
    }
  }
`;

export const updateShipmentItemsGql = gql`
  mutation updateShipmentItems($transfers: [ShipmentMoveInput!]!) {
    updateShipmentItems(input: { transfers: $transfers }) {
      shipmentId
      referenceId
      status
      items {
        referenceId
        name
        quantity
      }
    }
  }
`;

export const splitShipmentItemsGql = gql`
  mutation splitShipmentItems($input: SplitShipmentItemsInput!) {
    splitShipmentItems(input: $input) {
      sourceShipment {
        shipmentId
        referenceId
        status
      }
      newShipment {
        shipmentId
        referenceId
        status
      }
    }
  }
`;

export const cancelShipmentItemsForReviewGql = gql`
  mutation cancelShipmentItemsForReview($input: CancelShipmentItemsInput!) {
    cancelShipmentItemsForReview(input: $input) {
      sourceShipment {
        shipmentId
        referenceId
        status
      }
    }
  }
`;

export const cancelShipmentItemsFromOrderGql = gql`
  mutation cancelShipmentItemsFromOrder($input: CancelShipmentItemsInput!) {
    cancelShipmentItemsFromOrder(input: $input) {
      sourceShipment {
        shipmentId
        referenceId
        status
      }
    }
  }
`;

export const getShipmentAuditEventsGql = gql`
  query getShipmentAuditEvents($shipmentId: String!, $referenceId: String!) {
    getShipmentAuditEvents(shipmentId: $shipmentId, referenceId: $referenceId) {
      count
      shipmentRequestId
      referenceId
      events {
        auditEventId
        auditEventType
        auditEventCode
        auditEventData
        shipmentRequestId
        referenceId
        createdTimestamp
        performedBy
        status
      }
      errors {
        auditEventId
        auditEventType
        auditEventCode
        auditEventData
        shipmentRequestId
        referenceId
        createdTimestamp
        performedBy
        status
      }
    }
  }
`;
